import { createSlice } from '@reduxjs/toolkit'
import { customApi } from 'shared/api/customApi'
import { sessionApi } from '../api/sessionApi'

interface SessionState {
    isAuthenticated: boolean
    resendEmail?: boolean
    isResetPassword?: boolean
    token: string
}

const initialState: SessionState = {
    isAuthenticated: false,
    resendEmail: false,
    isResetPassword: false,
    token: '',
}

/** Write a value to storage with JSON.stringify (matches existing storage format). */
function storeItem(storage: Storage, key: string, value: unknown): void {
    storage.setItem(key, JSON.stringify(value))
}

const sessionSlice = createSlice({
    name: 'session',
    initialState,
    reducers: {},
    extraReducers: (build) => {
        build.addMatcher(
            sessionApi.endpoints.signUp.matchFulfilled,
            (state, { payload }) => {
                sessionStorage.removeItem('accessToken')
                state.token = payload?.tokens.accessToken
                storeItem(
                    sessionStorage,
                    'accessToken',
                    payload?.tokens.accessToken
                )
                storeItem(
                    sessionStorage,
                    'refreshToken',
                    payload?.tokens.refreshToken
                )
                storeItem(sessionStorage, 'user', payload?.user)
            }
        )

        build.addMatcher(
            sessionApi.endpoints.resetPassword.matchFulfilled,
            (state) => {
                state.resendEmail = true
            }
        )
        build.addMatcher(
            sessionApi.endpoints.resetPasswordConfirmation.matchFulfilled,
            (state) => {
                state.isResetPassword = true
            }
        )

        build.addMatcher(
            customApi.endpoints?.refreshToken.matchFulfilled,
            (state, { payload }) => {
                localStorage.removeItem('accessToken')
                state.token = payload?.accessToken
                storeItem(localStorage, 'accessToken', payload?.accessToken)
                storeItem(sessionStorage, 'accessToken', payload?.accessToken)
            }
        )
    },
})

export const sessionReducer = sessionSlice.reducer
